import React from 'react';

import { Row, Col } from 'reactstrap';

const HomeAvatarQuote = () => (
  <Row className="mb-3">
    <Col
      md={{ pull: 1 }}
      className="d-flex align-items-center justify-content-end"
    >
      <img src="/assets/Avatar2.jpg" alt="Joe's Avatar" />
    </Col>
    <Col md={{ pull: 1 }} className="d-flex align-items-center">
      <h3
        className="m-0 pr-xl-5"
        style={{
          fontWeight: 200,
          fontFamily: 'Raleway',
          lineHeight: '1.25em'
        }}
      >
        "If you can't find time to smile and enjoy yourself while working, then what's the point?"
      </h3>
    </Col>
  </Row>
);

export default HomeAvatarQuote;



// WEBPACK FOOTER //
// ./src/HomeAvatarQuote.js